__turbopack_context__.v({
  "glow": "Yc0VFa_glow",
  "number": "Yc0VFa_number",
  "pulse": "Yc0VFa_pulse",
});
